export enum AuthRoutes {
  Login = '/auth/login',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/reset-password',
  ConfirmEmail = '/auth/confirm-email',
  CodeVerification = '/auth/code-verification',
}

export enum MainRoutes {
  Home = '/',
  AgencyList = '/admin/agencies',
  EmployeeList = ':agencyId/employees',
  VehicleList = ':agencyId/vehicles',
  EquipmentList = ':agencyId/equipment',
  InventoryLocations = ':agencyId/inventory-locations',
  NCICSearchRequest = ':agencyId/ncic-search-requests',
  UnitList = ':agencyId/units',
  CFSList = '/cfs',
  ActiveCFS = '/cfs-active',
  KaseList = '/cases',
  FireKaseList = '/fire-cases',
  TaskList = '/tasks',
  CamerasList = 'tools/cameras',
  CalendarScheduler = 'tools/calendar-scheduler',
  VendorList = ':agencyId/vendors',
  Help = '/help/release-notes',
  UnitTypeList = ':agencyId/unit-management/types',
  JmsManagement = '/jms/management',
  JmsOperations = '/jms/operations',
  JmsOperationsInmatesMovement = '/jms/operations/inmates-movement',
  Settings = '/settings',
  Analytics = '/analytics',
}

export enum MasterIndexRoutes {
  Persons = 'persons',
  Organizations = 'organizations',
  Vehicles = 'vehicles',
  Properties = 'properties',
  Address = 'address',
  Logs = 'logs',
}

export enum MasterIndexTabRoutes {
  Information = 'information',
  Related = 'related',
  Notes = 'notes',
  Flags = 'flags',
  AddressNotes = 'address-notes',
}

export enum EmployeeDetailsTabRoutes {
  Information = 'information',
  Devices = 'devices',
}
